var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrice3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.437,
    height: 54.437,
    viewBox: "0 0 54.437 54.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f78ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#f067ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c33c2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "price3",
    d: "M37.532,44.124a3.193,3.193,0,0,0,3.19-3.19V36.45A14.354,14.354,0,1,0,39.4,7.772a13.47,13.47,0,0,0-25.667,5.233,11.811,11.811,0,1,0-1.823,23.464h1.807v4.466a3.193,3.193,0,0,0,3.19,3.19h8.719v7.124H13.609a1.595,1.595,0,0,0,0,3.19H40.828a1.595,1.595,0,1,0,0-3.19H28.814V44.124Zm-20.627-13.4V23.71H30.727v1.807a1.595,1.595,0,1,0,3.19,0V23.71h3.615l0,7.017c-.011,0-1.118,0-20.629,0ZM3.19,24.667a8.7,8.7,0,0,1,11.666-8.095,1.6,1.6,0,0,0,2.128-1.693A10.3,10.3,0,0,1,36.877,9.986a1.6,1.6,0,0,0,1.793,1.043,11.167,11.167,0,1,1,1.982,22.229,3.167,3.167,0,0,0-.36-.936,3.168,3.168,0,0,0,.429-1.595V23.71a3.193,3.193,0,0,0-3.19-3.19H16.905a3.193,3.193,0,0,0-3.19,3.19v7.017a3.169,3.169,0,0,0,.429,1.595,3.165,3.165,0,0,0-.365.957H11.908A8.676,8.676,0,0,1,3.19,24.667Zm13.716,9.25H30.727v1.807a1.595,1.595,0,1,0,3.19,0V33.917h3.615s.011,7.017,0,7.017H16.905Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice3);
export default __webpack_public_path__ + "static/media/price3.57d22855cd02c05e9542311b2339145d.svg";
export { ForwardRef as ReactComponent };